import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';
import { version } from '../package.json'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

// for cm-chessboard
import './css/chessboard.css';
import './css/arrows.css';
import './css/markers.css';
import "./css/promotion-dialog.css"

// for ag grid
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
 import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
 import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme CSS

// for videos
import './css/video-js.css';

// for eyegaze and big buttons
import './css/eyegaze.css'

import 'vueperslides/dist/vueperslides.css'

import HoneybadgerVue from '@honeybadger-io/vue'
import { registerSW } from 'virtual:pwa-register'

registerSW({
  onRegistrationError(error) {
    console.warn('SW registration failed:', error)
  }
})

function isBot() {
  const ua = navigator.userAgent.toLowerCase()
  return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebot|ia_archiver|crawler|spider|bot/.test(ua)
}

const config = {
  apiKey: 'hbp_8xbYkcG1HMlpY9Ke9WcUWdCWhSu2DG0oEYyn',
  environment: 'production',
  revision: version,
  beforeNotify: (notice) => {
      // Use self instead of window so it safely resolves in Web/Service Workers
      const ua = (typeof self !== 'undefined' && self.navigator)
          ? self.navigator.userAgent
          : ''
      if (/googlebot|bingbot|playstore-google|bot|crawler|spider/i.test(ua)) return false
      if (notice.message === '{}') return false
      if (notice.message.includes('network error')) return false
      if (notice.message.includes('Error: Rejected')) return false
      if (notice.message.includes('Failed to register a ServiceWorker')) return false

      return true;
  }
}

import { createPinia } from 'pinia'
const pinia = createPinia()

const app = createApp(App)

// don't use honeybader in development
if (process.env.NODE_ENV === 'production') {
  console.log("**** this is production")
  app.use(HoneybadgerVue, config)
}
else {
  console.log("**** this is DEVELOPMENT")
}

app.use(IonicVue)
app.use(pinia)
app.use(router);
  
router.isReady().then(() => {
  app.mount('#app');
});